import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/fetch-duck";

const { Types, Creators } = createActions(
  {
    request: ["id", "onSuccess", "onFailure"],
    success: ["data"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "FETCH_CARRIER_RESPONSIBLE_EMAIL_" }
);

export interface FetchCarrierResponsibleEmailState extends IState {}

const INITIAL_STATE: FetchCarrierResponsibleEmailState = {
  data: null,
  loading: false,
  error: null,
};

const request = (state: FetchCarrierResponsibleEmailState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (
  state: FetchCarrierResponsibleEmailState,
  action: ISuccessAction
) =>
  update(state, {
    data: { $set: action.data || null },
    loading: { $set: false },
  });

const failure = (
  state: FetchCarrierResponsibleEmailState,
  action: IFailureAction
) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const fetchCarrierResponsibleEmail = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const FetchCarrierResponsibleEmailTypes = Types;
export const FetchCarrierResponsibleEmailActions = Creators;
